export default {
  signIn: 'Вход',
  signOut: 'Изход',
  points: 'точки',
  hyattSignInButton: 'Влезте в World of Hyatt',
};
